<template>
  <div v-if="deviceList.length ? false : true">
    <Index></Index>
  </div>

  <div class="header">
    <div class="title">{{ value ?? "" }}</div>

    <div style="margin-right: 58px; display: flex">
      <div
        @click="connectDevice"
        v-if="deviceList.length ? true : false"
        style="color: #fff; margin-right: 30px; cursor: pointer; color: #b5d8f1"
      >
        {{ language[languageValue]["连接新设备"] }}
      </div>
      <div
        style="
          width: 250px;
          margin-right: 20px;
          margin-top: -5px;
          color: #b5d8f1;
        "
        class="change-device"
      >
        <n-space vertical>
          <n-select v-model:value="value" :options="options" />
        </n-space>
      </div>
      <div>
        <n-popselect
          v-model:value="languageValue"
          :options="languageOptions"
          size="medium"
        >
          <img src="@/images/language.png" alt="" style="margin-right: 20px" />
        </n-popselect>

        <n-popover trigger="hover">
          <template #trigger>
            <a href="http://Waizowl.com" target="_blank">
              <img src="@/images/bag.png" alt="" />
            </a>
          </template>
          <span> {{ language[languageValue]["官网"] }}</span>
        </n-popover>
      </div>
    </div>
  </div>
  <div class="padding">
    <div>
      <div
        v-for="(item, index) in list"
        :key="index"
        @click="changeSettingFn(index)"
        style="display: flex; align-items: center; margin-bottom: 14px"
      >
        <div class="setting" :class="{ white: index === currentIndex }">
          <div>
            {{ language[languageValue][item] }}
          </div>
          <div>
            {{ index + 1 }}
          </div>
        </div>
      </div>
    </div>

    <div class="right" :key="currentIndex">
      <Options
        @emitIndex="getIndex"
        @emitReset="getReset"
        :currentIndex="saveIndex"
      ></Options>
      <div style="position: relative">
        <img
          :src="mouseImg[mouseType][mouseImgIndex]"
          alt=""
          class="mouse"
          id="mouse"
        />
        <div
          v-if="deviceName === 'cloudS'"
          :style="{
            backgroundColor: dpiColor[currentDpiColor],
            position: 'absolute',
            left: '210px',
            top: '142px',
            width: '20px',
            height: '10px',
            borderRadius: '10px',
          }"
        ></div>
      </div>

      <component
        :is="KEY_MAP[saveIndex]"
        @emitKeyIndex="getKeyIndex"
        @emitIndex="getIndex"
        :key="time"
      />
    </div>
  </div>
  <div class="footer">Waizowl Driver Software</div>
</template>

<script setup>
import Index from "@/pages/index.vue";
import Options from "@/pages/Options";
import Progress from "@/pages/progress.vue";
import KeyProgress from "@/pages/keyProgress.vue";
import Dpi from "@/pages/dpi.vue";
import Rate from "@/pages/rate.vue";
import Define from "@/pages/define.vue";
import System from "@/pages/system.vue";
import FirmWare from "@/pages/firmware.vue";
import { onMounted, ref, watch, watchEffect } from "vue";
import { language } from "@/hooks/util/i18n";
import { NSpace, NSelect, NPopselect, NPopover, useDialog } from "naive-ui";
import { useStore } from "@/hooks/stores/global";
import { storeToRefs } from "pinia";
import { getDevices, parseHexArray } from "@/common/index";
import { reportParams } from "@/common";
import { reqInitData, KEY_MAP as key_api_map } from "@/baseData/system";
import { getVersion } from "@/baseData/index";
import { sendReport, getCheckSum } from "@/common";
import { exportXml } from "@/common/index";

const main = useStore();
const dialog = useDialog();
const {
  device,
  changeSetting,
  keyData,
  indexData,
  deviceList,
  deviceCollections,
  languageValue,
  deviceName,
  allMacroPacket,
  currentMouse,
} = storeToRefs(main);
watch(languageValue, (newValue) => {
  if (newValue) {
    localStorage.setItem("language", newValue);
  }
});
watch(
  allMacroPacket,
  (newValue) => {
    console.log(newValue);
    localStorage.setItem(
      `${currentMouse.value}-macro`,
      JSON.stringify(newValue)
    );
  },
  { deep: true }
);
const connectDevice = async () => {
  // 连接设备
  await navigator.hid.requestDevice({
    filters: [
      {
        vendorId: "0x1915",
        productId: "0x072C",
      },

      // 有线
      {
        vendorId: "0x1915",
        productId: "0x07A1",
      },
      {
        vendorId: "0x1915",
        productId: "0x07A0",
      },
      // 无线
      {
        vendorId: "0x1915",
        productId: "0x0727",
      },
      {
        vendorId: "0x1915",
        productId: "0x0728",
      },
      // 光微动有线
      {
        vendorId: "0x1915",
        productId: "0x07A2",
      },
      // 升级模式
      {
        vendorId: "0x1915",
        productId: "0x0829",
      },
      {
        vendorId: "0x1915",
        productId: "0x0828",
      },
      // 837鼠标
      {
        vendorId: "0x1915",
        productId: "0x07A3",
      },
    ],
  });
  if (!device.value) {
    location.reload();
  }
  // 存储连接的设备
  await getDevices();
};
const list = ["配置", "配置", "配置", "配置", "配置"];
const dpiColor = ["#ff0000", "#00ff00", "#0000ff", "#ff00ff", "#00ffff"];
const mouseImgIndex = ref(7);
const mouseType = ref("cloud");
const value = ref(null);
const options = ref([]);

const languageOptions = [
  {
    label: "简体中文",
    value: "zh",
  },
  {
    label: "English",
    value: "en",
  },
  {
    label: "日本語",
    value: "jp",
  },
  // {
  //   label: "한국어",
  //   value: "kr",
  // },
];
const mouseImg = {
  cloud: [
    require("@/images/mouse/cloud1.png"),
    require("@/images/mouse/cloud2.png"),
    require("@/images/mouse/cloud3.png"),
    require("@/images/mouse/cloud5.png"),
    require("@/images/mouse/cloud4.png"),
    require("@/images/mouse/cloud6.png"),
    require("@/images/mouse/cloud7.png"),
    require("@/images/mouse/cloud.png"),
  ],
  v2: [
    require("@/images/mouse/left.png"),
    require("@/images/mouse/right.png"),
    require("@/images/mouse/middle.png"),
    require("@/images/mouse/retreat.png"),
    require("@/images/mouse/forward.png"),
    require("@/images/mouse/scroll-top.png"),
    require("@/images/mouse/scroll-bottom.png"),
    require("@/assets/mouse.png"),
  ],
  CloudS: [
    require("@/images/mouse/CloudS1.png"),
    require("@/images/mouse/CloudS2.png"),
    require("@/images/mouse/CloudS3.png"),
    require("@/images/mouse/CloudS5.png"),
    require("@/images/mouse/CloudS4.png"),
    require("@/images/mouse/CloudS6.png"),
    require("@/images/mouse/CloudS7.png"),
    require("@/images/mouse/CloudS.png"),
  ],
};

const time = ref(+new Date());
const getReset = (value) => {
  time.value = value;
};
const KEY_MAP = {
  0: Progress,
  1: KeyProgress,
  2: Dpi,
  3: Rate,
  4: Define,
  5: System,
  6: FirmWare,
};
const key_dpi_value = {
  "01": 1,
  "03": 2,
  "07": 3,
  "0f": 4,
  "0F": 4,
  "1f": 5,
  "1F": 5,
  1: "01",
  2: "03",
  3: "07",
  4: "0f",
  5: "1f",
};
const currentIndex = ref(0);
const saveIndex = ref(0);
const isExport = ref(false);
const firstData = "00020082010";
const secondData =
  "00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000";
const getIndex = (index) => {
  saveIndex.value = index;
  mouseImgIndex.value = index !== 1 ? 7 : 0;
};

const getKeyIndex = (index) => {
  mouseImgIndex.value = index;
};

const currentDpiColor = ref(0);
watch(changeSetting, (newValue) => {
  if (newValue) {
    const arr = newValue.split(" ");
    const value = parseInt(arr[9], 16);
    if (currentDpiColor.value !== value) {
      currentDpiColor.value = value;
    }
  }
});
watchEffect(() => {
  if (indexData.value && keyData.value && isExport.value) {
    const keydata = keyData.value.split(" ");
    const dpidata = indexData.value.split(" ");
    console.log("--dpidata", dpidata);
    main.getKeyData("");
    main.addDpi("");
    isExport.value = false;
    let isFlag = "";
    for (let i = 0; i < Object.values(key_api_map).length; i++) {
      if (Object.values(key_api_map)[i] == dpidata[5].toLowerCase()) {
        isFlag = Object.keys(key_api_map)[i];
        break;
      }
    }
    const macroinfo = {
      profileinfo: {
        _attributes: {
          name: "配置" + (currentIndex.value + 1),
        },
        keyitems: {
          item: [],
        },
        Mouse_DPI: {
          _attributes: {
            dpi_count: key_dpi_value[dpidata[7]],
            dpi_index: parseInt(dpidata[8], 16),
            dpi_flag: 5,
          },
          DPI1: {
            _attributes: {
              value: parseInt(dpidata[9], 16) + parseInt(dpidata[10], 16) * 256,
              color: "255",
            },
          },
          DPI2: {
            _attributes: {
              value:
                parseInt(dpidata[13], 16) + parseInt(dpidata[14], 16) * 256,
              color: "65280",
            },
          },
          DPI3: {
            _attributes: {
              value:
                parseInt(dpidata[17], 16) + parseInt(dpidata[18], 16) * 256,
              color: "16711680",
            },
          },
          DPI4: {
            _attributes: {
              value:
                parseInt(dpidata[21], 16) + parseInt(dpidata[22], 16) * 256,
              color: "8388736",
            },
          },
          DPI5: {
            _attributes: {
              value:
                parseInt(dpidata[25], 16) + parseInt(dpidata[26], 16) * 256,
              color: "16777215",
            },
          },
        },
        Mouse: {
          button_respondtime: {
            _attributes: {
              value: parseInt(dpidata[48], 16),
            },
          },
          report_rate: {
            _attributes: {
              value: 3,
            },
          },
          sensor_flag: {
            _attributes: {
              value:
                (isFlag[0] == 1 ? 4 : 0) +
                (isFlag[1] == 1 ? 8 : 0) +
                (isFlag[2] == 1 ? 16 : 0),
            },
          },
          liftoff_height: {
            _attributes: {
              value: dpidata[37] === "01" ? 1 : 2,
            },
          },
          scroll_flag: {
            _attributes: {
              value: isFlag[3] == 0 ? 1 : 2,
            },
          },
          "e-sports_flag": {
            _attributes: {
              value: isFlag[4] == 0 ? 1 : 2,
            },
          },
          leftbtn_lock: {
            _attributes: {
              value: 1,
            },
          },
        },
      },
    };

    const keyArr = [
      "左键",
      "右键",
      "中键",
      "前进",
      "后退",
      "向上滚动",
      "向下滚动",
    ];
    let count = 0;
    let str = "";
    const keyValueArr = [];
    for (let i = 5; i < 41; i++) {
      str += keydata[i];
      count++;
      if (count === 4) {
        keyValueArr.push(str);

        count = 0;
        str = "";
      }
    }
    // return
    for (let i = 0; i < keyValueArr.length; i++) {
      if (i === 5 || i === 6) {
        continue;
      }
      macroinfo.profileinfo.keyitems.item.push({
        _attributes: {
          macro_desc: keyArr[i > 6 ? i - 2 : i],
          keyData: keyValueArr[i],
        },
      });
    }

    exportXml(macroinfo, "profile", "profileinfo");
  }
});
watchEffect(() => {
  if (
    deviceList.value &&
    deviceCollections.value &&
    deviceList.value.length &&
    Object.keys(deviceCollections.value).length
  ) {
    options.value = deviceList.value;
    value.value = deviceList.value[0].value;
  }
});
watch(value, async (newValue) => {
  if (deviceCollections.value && Object.keys(deviceCollections.value).length) {
    // 查看浏览器中是否有当前设备宏定义的存储值
    main.getLocalValue("nameList", []);
    main.getLocalValue("event", []);
    if (localStorage.hasOwnProperty(newValue)) {
      const { name, event } = JSON.parse(localStorage.getItem(newValue));
      main.getLocalValue("nameList", name);
      main.getLocalValue("eventList", event);
    }
    saveIndex.value = 0;
    mouseImgIndex.value = 7;
    main.setCurrentMouse(newValue);
    console.log("new", newValue);
    if (newValue === "OGM V2" || newValue === "OGM V2 GV") {
      mouseType.value = "v2";
      main.saveDeviceName("v2");
    } else if (newValue === "Cloud Hawkeye") {
      mouseType.value = "cloud";
      main.saveDeviceName("cloud");
    } else if (newValue === "Cloud S") {
      mouseType.value = "CloudS";
      main.saveDeviceName("cloudS");
    }

    main.saveDevice(deviceCollections.value[newValue]);
    time.value = +new Date();
    const data =
      "00010081010000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000";
    if (device.value) {
      // 读取鼠标请求数据
      let getSettingData = reportParams(data + getCheckSum(data));
      await device.value.sendReport(
        getSettingData.reportId,
        getSettingData.reportData
      );
    }

    // 获取版本信息getVersion
    setTimeout(async () => {
      let { reportId, reportData } = reportParams(
        getVersion + getCheckSum(getVersion)
      );
      // 发送数据
      await device.value.sendReport(reportId, reportData);
    }, 200);
    // 获取版本信息getVersion
    setTimeout(async () => {
      let data = parseHexArray(getVersion + "20");

      let reportId = data.getUint8(0);
      let reportData = new Uint8Array(data.buffer).slice(1);
      // 发送数据
      await device.value.sendReport(reportId, reportData);
    }, 300);
  }
});

const changeSettingFn = async (index) => {
  if (!indexData.value) {
    dialog.warning({
      showIcon: false,
      closable: false,
      content:
        language[languageValue.value]["请使用2.4G模式或者有线模式连接设备"],
      positiveText: "确认",
      positiveButtonProps: {
        color: "#b5d8f1",
        textColor: "black",
        style: {
          width: "62px",
          height: "22px",
        },
      },
      style: {
        background: "#031321",
        width: "134px",
        color: "#b5d8f1",
        width: "454px",
        border: "1px solid #114b5d",
        borderRadius: "8px",
      },
    });

    return;
  }
  main.getChangeSetting("");
  main.initData("");
  currentIndex.value = index;

  if (device.value) {
    const changeSettingData = firstData + index + secondData;
    // 切换鼠标配置的数据
    const value = getCheckSum(changeSettingData);
    await sendReport(changeSettingData + value);
  }
};

onMounted(async () => {
  // 监听设备的拔出
  navigator.hid.ondisconnect = (e) => {
    console.log("拔出");

    location.reload();
    main.saveDevice("");
  };
  await getDevices();
  if (localStorage.hasOwnProperty("language")) {
    const value = localStorage.getItem("language");
    main.setLanguageValue(value);
  }
  if (localStorage.hasOwnProperty(`${currentMouse.value}-macro`)) {
    const obj = JSON.parse(localStorage.getItem(`${currentMouse.value}-macro`));

    for (let key in obj) {
      main.addPacket(key, obj[key]);
    }
  }
  const data =
    "00010081010000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000";
  if (device.value) {
    // 读取鼠标dpi的数据

    setTimeout(async () => {
      let { reportId, reportData } = reportParams(
        reqInitData + getCheckSum(reqInitData)
      );
      // 发送数据
      await device.value.sendReport(reportId, reportData);
    }, 100);

    // 获取版本信息getVersion
    setTimeout(async () => {
      let { reportId, reportData } = reportParams(
        getVersion + getCheckSum(getVersion)
      );
      // 发送数据
      await device.value.sendReport(reportId, reportData);
    }, 200);
    // 获取版本信息getVersion
    setTimeout(async () => {
      let data = parseHexArray(getVersion + "20");

      let reportId = data.getUint8(0);
      let reportData = new Uint8Array(data.buffer).slice(1);
      // 发送数据
      await device.value.sendReport(reportId, reportData);
    }, 300);
    // 读取鼠标请求数据
    let getSettingData = reportParams(data + getCheckSum(data));
    await device.value.sendReport(
      getSettingData.reportId,
      getSettingData.reportData
    );
  }
});
watch(
  changeSetting,
  (newValue) => {
    if (!newValue) return;
    if (newValue) {
      const arr = newValue.split(" ");

      currentIndex.value = parseInt(arr[8], 16);
    }
  }
  // { once: true }
);
watch(currentIndex, (newValue, oldValue) => {
  saveIndex.value = 0;
});
</script>

<style lang="less" scoped>
.header {
  width: 1920px;
  height: 94px;

  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  box-sizing: border-box;
  padding-top: 28px;
  padding-left: 58px;
  /deep/ .change-device .n-base-selection-label {
    background-color: #060b11;
  }
  /deep/ .change-device .n-base-selection-input__content {
    color: #b5d8f1;
  }
  .title {
    font-family: PingFang;
    font-weight: 800;
    font-size: 22px;
    color: rgba(255, 255, 255, 0);
    text-stroke: 1px #b5d7f1;
    -webkit-text-stroke: 1px #b5d7f1;
  }
}
.padding {
  display: flex;
  width: 1920px;
  margin: 0 auto;
  padding-left: 58px;
  box-sizing: border-box;
  .setting {
    display: flex;
    width: 75px;
    justify-content: space-between;
    font-family: PingFang;
    font-weight: bold;
    font-size: 14px;
    color: #637077;
    cursor: pointer;
  }
  .white {
    color: #fff;
  }
  .right {
    box-sizing: border-box;
    width: 1482px;
    min-width: 1482px;
    height: 846px;
    background: #0a1115;
    border-radius: 15px;
    border: 1px solid #38444d;
    box-shadow: 0px 0px 10px #38444d;
    margin-left: 108px;
    padding: 0 64px;
    display: flex;
    // position:relative;
  }
  .mouse {
    width: 384px;
    height: 663px;
    margin-top: 79px;
    margin-right: 223px;
    margin-left: 19px;
  }
}

.footer {
  height: 91px;
  line-height: 91px;
  font-family: PingFang;
  font-weight: 400;
  font-size: 14px;
  color: #637077;

  opacity: 0.5;
  text-align: center;
}
</style>
